import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { FileService } from '../../service/file.service';

@Component({
  selector: 'app-app-upload-video',
  templateUrl: './app-upload-video.component.html',
  styleUrls: ['./app-upload-video.component.scss']
})
export class AppUploadVideoComponent implements OnInit {
  dragOver = false;
  error: boolean | null | undefined = false;
  @Input() boxWidth: string = '2rem';
  @Input() boxHeight: string = '2rem';
  @Input() fileType: string[] = ['video/mp4', 'video/mkv', 'video/webm'];
  @Output() onVideoSelected = new EventEmitter<string>();
  @Output() onVideoSelectedBlob = new EventEmitter<Blob>();
  @Input() video?: string;
  @Input() title = 'لطفا فایل ویدیو را انتخاب کنید';
  @Input() description = 'حداکثر حجم فایل ۲۰ کیلوبایت می‌باشد.';

  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  constructor(private fileService: FileService) {
  }


  getFile(evt: any): void {
    this.processImage(evt);
  }

  processImage($event: any) {
    $event.preventDefault();
    const file = $event.dataTransfer ? $event.dataTransfer.files[0] : $event.target.files[0];
    if (
      file &&
      (this.fileType.includes(file.type))
    ) {
      const reader = new FileReader();
      reader.onload = (fileReader: any) => {
        this.video = `data:${file.type};base64,` + btoa(fileReader.target.result);
        this.onVideoSelected.emit(this.video);
        this.onVideoSelectedBlob.emit(this.fileService.dataURIToBlob(this.video));
      };
      reader.readAsBinaryString(file);
    } else {
      this.Toast.fire({
        icon: 'error',
        text: `فرمت فایل انتخابی باید یکی از فرمت‌های ${this.fileType.join(' ')} باشد.`
      });
    }
  }

  onDrop($event: any): void {
    this.processImage($event);
    this.dragOver = false;
  }

  drag($event: any): void {
    $event.preventDefault();
    $event.dataTransfer.effectAllowed = 'none';
    $event.dataTransfer.dropEffect = 'none';
  }

  ngOnInit(): void {
  }


}
